import Vue from 'vue'
import { configureFontAwesome } from '@/setup/fontawesome'
import { configureGlobalImports } from '@/setup/global-imports'
import setupInterceptors from '@/setup/interceptors';
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false

configureFontAwesome()
configureGlobalImports()
setupInterceptors()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
